const GOOGLE_ADS_LEAD_CONVERSION = 'AW-18420279487/XPaUCODjvuscEL_RvM9E';

export function trackLeadConversion() {
  return new Promise((resolve) => {
    let isComplete = false;
    const complete = () => {
      if (isComplete) return;
      isComplete = true;
      resolve();
    };

    if (typeof window.gtag !== 'function') {
      complete();
      return;
    }

    window.gtag('event', 'conversion', {
      send_to: GOOGLE_ADS_LEAD_CONVERSION,
      value: 1.0,
      currency: 'USD',
      event_callback: complete,
      event_timeout: 800,
    });

    window.setTimeout(complete, 850);
  });
}
